export default __webpack_public_path__ + "static/media/sidebar-8.3fbeea1a.png";